

export default class Electron{

    static Instance(){
        return (window as any).Electron;
    }
}